import React from "react";
import SignalIcon from "./SignalIcon";
import "./tracker/signalTracker.scss";

// A label with its explanation one hover (or focus) away, so the card stays short.
export const Info = ({ text }) => (
  <span className="st-info" tabIndex={0} aria-label={text}>
    <SignalIcon id="info" size={13} />
    <span className="st-info__tip" role="tooltip">{text}</span>
  </span>
);
